import reducer from './products.reducer';
import actions from './products.actions';
import selectors from './products.selectors';

export default {
  reducer,
  actions,
  selectors,
};
